/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BadRequestResponse,
  GetTaskDetailsParams,
  TaskApiFailureResponseResponse,
  TaskApiForbiddenResponse,
  TaskApiUnauthorizedResponse,
  TaskDetailsResponseResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary Get task Details
 */
export const getTaskDetails = (params?: GetTaskDetailsParams, signal?: AbortSignal) => {
  return customInstance<TaskDetailsResponseResponse>({
    url: `/BboTaskApi/v1`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetTaskDetailsQueryKey = (params?: GetTaskDetailsParams) => {
  return [`/BboTaskApi/v1`, ...(params ? [params] : [])] as const;
};

export const getGetTaskDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTaskDetails>>,
  TError = ErrorType<
    | BadRequestResponse
    | TaskApiUnauthorizedResponse
    | TaskApiForbiddenResponse
    | TaskApiFailureResponseResponse
  >,
>(
  params?: GetTaskDetailsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskDetails>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTaskDetailsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskDetails>>> = ({ signal }) =>
    getTaskDetails(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTaskDetails>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTaskDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getTaskDetails>>>;
export type GetTaskDetailsQueryError = ErrorType<
  | BadRequestResponse
  | TaskApiUnauthorizedResponse
  | TaskApiForbiddenResponse
  | TaskApiFailureResponseResponse
>;

/**
 * @summary Get task Details
 */
export const useGetTaskDetails = <
  TData = Awaited<ReturnType<typeof getTaskDetails>>,
  TError = ErrorType<
    | BadRequestResponse
    | TaskApiUnauthorizedResponse
    | TaskApiForbiddenResponse
    | TaskApiFailureResponseResponse
  >,
>(
  params?: GetTaskDetailsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskDetails>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTaskDetailsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
